<div class="mapfre-slider-buttons">
  <img [ngClass]="{'disabled':isCarouselStart}"
    (click)="onSlidePrev()"
    src="assets/icons/arrow-left-primary.svg"
    alt="">
  <img
    [ngClass]="{'disabled':isCarouselEnd}"
    (click)="onSlideNext()"
    src="assets/icons/arrow-right-primary.svg"
    alt="">
</div>